import React from "react";
import Section from "components/Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "components/SectionHeader";

function TermsAndConditionsGeneral(props) {
  return (
    <Section>
      <Container>
              <SectionHeader
                className="text-center"
                title="Draudimo sąlygos"
                size={1}
                spaced={true}
              />
<p>Puslapis paskutinį kartą buvo atnaujintas 2021-06-14</p>
<h1>Jau greitai</h1>
<p>Deramės su draudimo paslaugos partneriu dėl geriausių sąlygų Jums.</p>
        </Container>
    </Section>
  );
}

export default TermsAndConditionsGeneral;